import { render } from "./ReportProducts.vue?vue&type=template&id=5da1125d&scoped=true&ts=true"
import script from "./ReportProducts.vue?vue&type=script&lang=ts"
export * from "./ReportProducts.vue?vue&type=script&lang=ts"

import "./ReportProducts.vue?vue&type=style&index=0&id=5da1125d&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/pontuei/pontuei-painel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da1125d"]])

export default __exports__